module.exports = __webpack_public_path__ + "static/media/GTEestiDisplay-Bold.5e98c525.woff";